/**
 * Frontend wrapper for the renderDrawing Cloud Function (B6.4).
 *
 * The Function returns 202 Accepted with { jobId, statusDocPath } and runs
 * the actual TechDraw render asynchronously. The caller subscribes to the
 * Firestore job doc via useDrawingJob() / useLatestDrawingJob() for status.
 */

import { fetchFirebaseFunction } from '@/lib/firebaseFunctions';

export type RenderDrawingPayload = {
  conversationId: string;
  messageId: string;
  artifactId?: string;
  spec: Record<string, unknown>;
  drawing?: Record<string, unknown>;
  outputs?: Array<'svg' | 'pdf' | 'dxf'>;
  renderFingerprint?: string;
};

export type RenderDrawingResponse = {
  jobId: string;
  mode: 'cloud_tasks' | 'direct_dev';
  taskName?: string;
  statusDocPath: string;
};

export async function triggerRenderDrawing(
  payload: RenderDrawingPayload,
): Promise<RenderDrawingResponse> {
  const res = await fetchFirebaseFunction('renderDrawing', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let detail: unknown = null;
    try {
      detail = await res.json();
    } catch {
      detail = await res.text();
    }
    throw new Error(
      `renderDrawing failed (${res.status}): ${
        typeof detail === 'string' ? detail : JSON.stringify(detail)
      }`,
    );
  }
  return (await res.json()) as RenderDrawingResponse;
}
